/* src/app/modules/subscription/subscription.component.css */
.main-container {
  margin-left: 240px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.header {
  background-color: #fff;
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e2e8f0;
}
.header-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
}
.header-tools {
  display: flex;
  align-items: center;
  gap: 20px;
  color: #64748b;
}
.content-body {
  padding: 30px 40px;
  max-width: 100%;
  width: 100%;
}
.plan-card {
  background:
    linear-gradient(
      135deg,
      #1e293b 0%,
      #0f172a 100%);
  border-radius: 16px;
  padding: 30px 40px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  position: relative;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
}
.badge-current {
  background-color: #3b3a30;
  color: #e3fd64;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
  display: inline-block;
}
.plan-name {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 8px;
}
.plan-status {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #94a3b8;
  font-size: 0.9rem;
}
.status-dot {
  width: 8px;
  height: 8px;
  background-color: #22c55e;
  border-radius: 50%;
}
.plan-price-block {
  text-align: right;
}
.price-value {
  font-size: 2.2rem;
  font-weight: 700;
  color: #e3fd64;
}
.price-period {
  font-size: 0.9rem;
  color: #94a3b8;
  font-weight: 400;
}
.renewal-date {
  font-size: 0.8rem;
  color: #94a3b8;
  margin-top: 5px;
}
.cancellation-warning {
  color: #ef4444;
  font-weight: 600;
}
.btn-upgrade {
  background-color: #e3fd64;
  color: #1a1c2c;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  margin-left: 40px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.section-label {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  font-size: 1.1rem;
  margin-bottom: 20px;
}
.label-icon {
  width: 20px;
  height: 20px;
  background-color: #e3fd64;
  border-radius: 4px;
}
.promo-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 25px;
  margin-bottom: 30px;
}
.promo-card {
  background-color: #fff;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  border: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
}
.promo-icon-box {
  width: 48px;
  height: 48px;
  background-color: #fffbeb;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.promo-title {
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 12px;
}
.promo-desc {
  font-size: 0.9rem;
  color: #64748b;
  line-height: 1.5;
  margin-bottom: 30px;
  flex-grow: 1;
}
.promo-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.price-strike {
  text-decoration: line-through;
  color: #94a3b8;
  margin-right: 8px;
  font-size: 0.9rem;
}
.price-free {
  color: var(--cf-brand-dark);
  font-weight: 700;
  font-size: 1.1rem;
}
.btn-activate {
  background: transparent;
  border: none;
  color: #1e293b;
  font-weight: 700;
  font-size: 0.9rem;
  cursor: pointer;
}
.ocr-card {
  background-color: #fff;
  border-radius: 12px;
  padding: 30px;
  display: flex;
  gap: 40px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  border: 1px solid #f1f5f9;
  margin-bottom: 50px;
}
.ocr-controls {
  flex-grow: 1;
}
.ocr-title {
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 10px;
}
.ocr-subtitle {
  color: #64748b;
  font-size: 0.9rem;
  margin-bottom: 40px;
}
.slider-container {
  position: relative;
  padding: 10px 0;
}
.slider-track {
  height: 6px;
  background: #e2e8f0;
  border-radius: 3px;
  width: 100%;
  position: relative;
}
.slider-thumb {
  width: 20px;
  height: 20px;
  background: var(--cf-brand-dark);
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 25%;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 0 6px rgba(212, 143, 0, 0.2);
}
.slider-labels {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  color: #94a3b8;
  font-size: 0.75rem;
  font-weight: 600;
}
.estimation-box {
  width: 240px;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.estimation-label {
  color: #64748b;
  font-size: 0.8rem;
  margin-bottom: 8px;
}
.estimation-value {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 15px;
}
.estimation-value span {
  font-size: 1rem;
  font-weight: 400;
  color: #94a3b8;
}
.estimation-cost {
  background-color: #fffbeb;
  color: #d97706;
  font-weight: 700;
  padding: 10px;
  border-radius: 8px;
  font-size: 0.9rem;
}
.footer-toolbar {
  border-top: 1px solid #e2e8f0;
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
}
.footer-left {
  display: flex;
  gap: 15px;
}
.btn-footer {
  padding: 10px 24px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
}
.btn-dark {
  background-color: #1a1c2c;
  color: #fff;
}
.btn-light {
  background-color: #f1f5f9;
  color: #1e293b;
}
.btn-cancel {
  color: #ef4444;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 600;
}
/*# sourceMappingURL=subscription.component.css.map */
